import React from 'react';
import { motion } from 'framer-motion';
const metrics = [{
  value: 'Hasta 70%',
  label: 'de ganancia por focaccia'
}, {
  value: '$3.000 - $5.000',
  label: 'por unidad vendida'
}, {
  value: '30 días',
  label: 'para empezar a vender'
}];
export function MetricsSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#2A1E0F] relative border-y border-white/5" data-id="element-178">
      <div className="max-w-6xl mx-auto" data-id="element-179">
        <div className="grid sm:grid-cols-3 gap-12 text-center" data-id="element-180">
          {metrics.map((metric, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="flex flex-col items-center" data-id="element-181">
              <span className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-gold mb-4" data-id="element-182">
                {metric.value}
              </span>
              <span className="text-cream-muted text-lg max-w-[200px] leading-snug" data-id="element-183">
                {metric.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}